import { Link } from "react-router-dom";
import "./Ambassadors.css";
import SwirlIcon from "./components/SwirlIcon";

const Ambassadors = () => {
  return (
    <div className="amb-page amb-story">
      <div className="amb-inner">
        <div className="amb-top-row">
          <Link to="/" className="amb-wordmark amb-wordmark--light">
            squaay<span className="dot">.</span>
          </Link>
          <SwirlIcon size={40} light />
        </div>

        <div className="amb-eyebrow">Now hiring</div>
        <div className="amb-headline">
          Campus
          <br />
          Ambassadors
        </div>
        <div className="amb-sub">
          Earn real money connecting your campus to Squaay — refer, get
          rewarded, level up.
        </div>

        <div className="amb-stat-row">
          <div className="amb-stat">
            <div className="amb-stat-n">₦500</div>
            <div className="amb-stat-l">per referral, both sides</div>
          </div>
          <div className="amb-stat">
            <div className="amb-stat-n">50</div>
            <div className="amb-stat-l">spots open</div>
          </div>
        </div>

        <div className="amb-cta">
          <Link to="/ambassadors/apply" className="amb-pill amb-pill--block">
            Get started
          </Link>
        </div>
      </div>
    </div>
  );
};

export default Ambassadors;
